<template>
  <div>
    <div class="title text-center">Import Instructions For One America</div>
    <div class="text-center my-4">Please upload the policy illustration</div>
    <div>
      <v-file-input
        v-model="importData"
        placeholder="Choose File"
        outlined
        prepend-icon="mdi-file-pdf"
        dense
      ></v-file-input>
    </div>
    <div class="text-center my-2">
      <v-btn color="primary" :disabled="!importable" :loading="importing" @click="submitToApi()">Upload</v-btn>
    </div>
  </div>
</template>
<script>
export default {
  name: 'OneAmerica',
  data() {
    return {
      importing: false,
      importData: null
    }
  },
  computed: {
    importable() {
      if(!this.importData) return false
      return true
    }
  },
  methods: {
    submitToApi() {
      this.importing = true

      let data = new FormData()
      data.append("data", this.importData)
      data.append('provider', 'ONEAMERICA')

      this.$http.post('policies/parse', data, { headers: { 'Content-Type': 'multipart/form-data' }})
        .then(response => {
          this.$emit('on-imported', Object.values(response.data))
        })
        .catch(err => {
          console.log(err)
          this.$swal.fire('Something Went Wrong', 'Please try again', 'error')
        })
        .finally(() => {
          this.importing = false
        })
    }
  }
}
</script>